import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmtDate(v) {
    if (!v) return '-';
    try {
        return new Intl.DateTimeFormat('pl-PL', {
            dateStyle: 'medium',
            timeStyle: 'medium'
        }).format(new Date(v));
    } catch {
        return String(v);
    }
}

function fmtTimeFromClientTs(clientTs) {
    const n = Number(clientTs);
    if (!Number.isFinite(n)) return '-';
    return fmtDate(n);
}

function flagLabel(type) {
    const labels = {
        visibility_hidden: 'Ukrycie karty / przełączenie okna',
        tab_blur: 'Utrata fokusa okna',
        fullscreen_exit: 'Wyjście z pełnego ekranu',
        copy_attempt: 'Próba kopiowania',
        cut_attempt: 'Próba wycięcia',
        paste_attempt: 'Próba wklejenia',
        select_all_attempt: 'Próba zaznaczenia wszystkiego',
        printscreen_attempt: 'Próba zrzutu ekranu',
        print_attempt: 'Próba drukowania',
        shortcut_blocked: 'Zablokowany skrót',
        contextmenu: 'Menu kontekstowe',
        drag: 'Przeciąganie',
        face_missing: 'Brak twarzy',
        multi_face: 'Wiele twarzy',
        camera_off: 'Kamera wyłączona',
        mic_muted: 'Mikrofon wyciszony',
        noise: 'Hałas',
        conversation: 'Rozmowa'
    };
    return labels[type] || type || 'Flaga';
}

export default function AttemptFlags() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({ loading: true, err: '', flags: [] });

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`/api/exam/attempts/${id}/flags`, {
                    credentials: 'include',
                    headers: { ...authHeader() },
                    cache: 'no-store'
                });
                const j = await r.json().catch(() => ({}));
                if (!r.ok) throw new Error(j?.blad || `Błąd pobierania flag (${r.status})`);
                if (!cancelled) setState({ loading: false, err: '', flags: Array.isArray(j.flags) ? j.flags : [] });
            } catch (e) {
                if (!cancelled) setState({ loading: false, err: e.message || 'Błąd pobierania flag', flags: [] });
            }
        })();
        return () => { cancelled = true; };
    }, [id]);

    const flags = useMemo(() => {
        return [...state.flags].sort((a, b) => (Number(a.clientTs) || 0) - (Number(b.clientTs) || 0));
    }, [state.flags]);

    return (
        <div style={{ maxWidth: 1000, padding: '0 16px', marginTop: 80, marginBottom: 30 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <button className="but-smal" onClick={() => navigate(`/prowadzacy/attempt/${id}`)}>
                    Powrót
                </button>
                <h1 style={{ margin: 0 }}>Flagi podejścia</h1>
            </div>

            <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, background: '#fff', padding: 14 }}>
                <div style={{ marginBottom: 12, color: '#6b7280' }}>
                    Lista zdarzeń zapisanych podczas egzaminu. Dla podejść bez proctoringu wideo flagi nie są synchronizowane z nagraniem.
                </div>

                {state.loading ? (
                    <div>Ładowanie…</div>
                ) : state.err ? (
                    <div style={{ color: '#dc2626' }}>{state.err}</div>
                ) : !flags.length ? (
                    <div>Brak flag dla tego podejścia.</div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>
                                    <th style={{ padding: '8px' }}>Czas</th>
                                    <th style={{ padding: '8px' }}>Typ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {flags.map((f, idx) => (
                                    <tr key={f.id ?? idx} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>{fmtTimeFromClientTs(f.clientTs)}</td>
                                        <td style={{ padding: '8px' }}>
                                            <div style={{ fontWeight: 700 }}>{flagLabel(f.type)}</div>
                                            <code style={{ fontSize: 12, color: '#6b7280' }}>{f.type}</code>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
